import { PaginatedColumn } from '../types/app';

export const DEVICE_TABLE_COLUMNS_NAME: PaginatedColumn[] = [
  {
    label: 'Ident',
    key: 'ident',
  },
  {
    label: 'Tipo de GPS',
    key: 'gpsType',
  },
  {
    label: 'Model',
    key: 'model',
  },
  {
    label: 'Marca',
    key: 'brand',
  },
  {
    label: 'Posición actual',
    key: 'cs',
  },
  {
    label: 'Posición sin asset',
    key: 'hsWithoutAsset',
  },
  {
    label: 'Límite de MB',
    key: 'maxMb',
  },
  {
    label: 'Acciones',
    key: 'actions',
    minWidth: 120,
    maxWidth: 120,
    centered: true,
  },
];
